// extracted by mini-css-extract-plugin
module.exports = {"courseCardPromo":"CourseCardPromo__courseCardPromo__2EKzE"};